export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: 'Full Stack Web-Development',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'SRM Institute oF Science And Technology',
        course: 'Bachelor of Automobile Engineering',
        startYear: '2015',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'Little Flower School',
        course: 'Higher Secondary Education',
        startYear: '2013',
        endYear: '2015'
    },


]